export default "//static.tradera.net/touchweb/static/output/images/tradera_new.4b16881c.svg";